import { render, staticRenderFns } from "./PaymentBtn.vue?vue&type=template&id=d1ee6dac"
import script from "./PaymentBtn.vue?vue&type=script&lang=js"
export * from "./PaymentBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports